import { Box, Divider, Paper, Stack, Typography } from "@mui/material";
import { formatDecimal } from "@shared";

import { DutyScheduleDistributionMetricsResponse } from "@/api";
import { useTranslation } from "@/translations";

interface Props {
  metrics: DutyScheduleDistributionMetricsResponse;
}

/** The three Kennzahlen of the current Dienstplan, derived from the figures of the Verteilungstabelle. */
export function DutyScheduleDistributionMetrics({ metrics }: Props) {
  const { t } = useTranslation();

  return (
    <Paper variant="outlined">
      <Box px={2} py={1.5}>
        <Typography variant="subtitle1" fontWeight={700}>
          {t("dutySchedule.detail.distribution.metrics.title")}
        </Typography>
      </Box>
      <Divider />
      <Stack divider={<Divider />}>
        <Figure label={t("dutySchedule.detail.distribution.metrics.hoursPerFte")} value={metrics.hoursPerFte} />
        <Figure
          label={t("dutySchedule.detail.distribution.metrics.hoursPerFtePerMonth")}
          value={metrics.hoursPerFtePerMonth}
        />
        <Figure label={t("dutySchedule.detail.distribution.metrics.bgsPerFte")} value={metrics.bgsPerFte} />
      </Stack>
    </Paper>
  );
}

function Figure({ label, value }: { label: string; value: number }) {
  const { i18n } = useTranslation();

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" px={2} py={1}>
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
      <Typography variant="body1" fontWeight={700}>
        {formatDecimal(value, i18n.language)}
      </Typography>
    </Stack>
  );
}
